import { render } from "./Quiz.vue?vue&type=template&id=5c2cb965"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ruwan/projects/eopp/eopp-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__